import React from "react";
import { AccountWarnings } from "./components/AccountWarnings";
import { AccountInterface, ApiHelper, SubscriptionInterface, UserHelper } from "./helpers";
import { Link } from "react-router-dom";

export const WelcomePage: React.FC = () => {

  const [subscriptions, setSubscriptions] = React.useState<SubscriptionInterface[]>(null);
  const [account, setAccount] = React.useState<AccountInterface>(null);

  const init = () => {
    ApiHelper.get<SubscriptionInterface[]>("/subscriptions")
      .then((data) => { setSubscriptions(data || []); })
      .catch(err => console.error("Failed to load subscriptions:", err));
    ApiHelper.get<AccountInterface>("/accounts/" + UserHelper.currentDepartment.accountId)
      .then((data: AccountInterface) => { setAccount(data); })
      .catch(err => console.error("Failed to load account:", err));
  }

  React.useEffect(init, [])

  const getVideo = () => {
    let result = "https://www.youtube.com/embed/eK2aOHm7TVs" //SignPresenter
    subscriptions?.forEach(s => {
      if (s.feedId === 2) result = "https://www.youtube.com/embed/NXO6yilZbro" //ChiroSign
    })
    if (account?.industry === "Orange") result = "https://www.youtube.com/embed/RP8Wd6wXxGM" //Orange
    return result;
  }

  return (
    <>
      <AccountWarnings />
      <div className="welcome-page">
        <div className="welcome-header">
          <h1>Welcome to SignPresenter</h1>
          <p className="welcome-subtitle">Your digital signage command center. Let's get your screens up and running.</p>
        </div>

        <div className="welcome-video-section">
          <div className="welcome-video-wrapper">
            <iframe
              title="Welcome Video"
              src={getVideo()}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <p className="video-caption">Watch this quick overview to get started</p>
        </div>

        <div className="welcome-steps-header">
          <h2>Get Started in 3 Easy Steps</h2>
        </div>

        <div className="welcome-steps">
          <Link to="/messages/" className="welcome-step-card">
            <div className="step-number">1</div>
            <div className="step-icon"><i className="far fa-image"></i></div>
            <h3>Create Content</h3>
            <p>Upload images, videos, or use our built-in designer to create stunning messages for your screens.</p>
            <span className="step-action">Get Started <i className="fas fa-arrow-right"></i></span>
          </Link>

          <Link to="/playlists/" className="welcome-step-card">
            <div className="step-number">2</div>
            <div className="step-icon"><i className="fas fa-list-ul"></i></div>
            <h3>Build Playlists</h3>
            <p>Organize your content into playlists for easy scheduling and management across multiple screens.</p>
            <span className="step-action">Create Playlist <i className="fas fa-arrow-right"></i></span>
          </Link>

          <Link to="/screens/" className="welcome-step-card">
            <div className="step-number">3</div>
            <div className="step-icon"><i className="fas fa-tv"></i></div>
            <h3>Schedule Screens</h3>
            <p>Connect your displays and set up schedules to show the right content at the right time.</p>
            <span className="step-action">Manage Screens <i className="fas fa-arrow-right"></i></span>
          </Link>
        </div>

        <div className="welcome-support">
          <div className="support-card">
            <h3><i className="fas fa-life-ring"></i> Need Help?</h3>
            <p>Our support team is here to assist you every step of the way.</p>
            <div className="support-links">
              <a href="https://support.signpresenter.com/topics/maininstructions.html" className="support-link">
                <i className="fas fa-book"></i> Setup Guide
              </a>
              <a href="https://support.signpresenter.com/" className="support-link">
                <i className="fas fa-question-circle"></i> Support Center
              </a>
              <a href="mailto:support@signpresenter.com" className="support-link">
                <i className="fas fa-envelope"></i> support@signpresenter.com
              </a>
              <a href="tel:918-994-2638" className="support-link">
                <i className="fas fa-phone"></i> 918-994-2638
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};